import { FiasCountry } from "../FiasWidgetTypes";

export const DEFAULT_FIAS_COUNTRY: FiasCountry = {
    code: "643",
    fullName: "Российская Федерация",
    shortName: "Россия",
};
